import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { PaymentControllerImpl, PaymentSubscriptionResponse } from "../../../../../payment/business";
import { PaymentPageFactoryImpl } from "../../../../../payment/site/api";
import { StrategyStatementPayment, SubscriptionPageControllerImpl } from "../../../../business";
import { SubscriptionStrings } from "../../../../business/core";
import { SubscriptionDataResponse, SubscriptionStatement } from "../../../interfaces";
import { SubscriptionPageFactoryImpl } from "../../factories";

interface IStrategyStatementButtonChange {
    subscription: SubscriptionStatement;
}

export const StrategyStatementButtonChangePlan: React.FC<IStrategyStatementButtonChange> = ({ subscription }) => {
    const [showModalPlans, setShowModalPlans] = useState<boolean>(false);
    const [showModalPayment, setShowModalPayment] = useState<boolean>(false);
    const strings = SubscriptionStrings['PTBR'].statement;
    const [isLoading, setLoading] = useState<Boolean>(true);
    const [plansData, setPlansData] = useState<SubscriptionDataResponse>();
    const [chosenData, setChosenData] = useState<StrategyStatementPayment>({ "id": "", "frequency": "" });
    const [paymentData, setPaymentData] = useState<PaymentSubscriptionResponse | null>(null);
    const signedPlan = {
        'signedPlanId': subscription.planId,
        'signedPlanFrequency': subscription.frequency
    };

    const factorySubscription = new SubscriptionPageFactoryImpl();
    const controllerSubscription = new SubscriptionPageControllerImpl();

    const factoryPayment = new PaymentPageFactoryImpl();
    const controllerPayment = new PaymentControllerImpl();

    const fetchDataPlans = async () => {
        try {
            const response = await controllerSubscription.onLoad();
            setLoading(false);
            setPlansData(response);
        } catch (error) {
            console.error("Erro na requisição:", error);
            setLoading(false);
        }
    };

    const fetchDataPayment = async () => {
        try {
            const response = await controllerPayment.onLoad(chosenData.id, chosenData.frequency);
            setLoading(false);
            setPaymentData(response);
        } catch (error) {
            console.error("Erro na requisição:", error);
            setLoading(false);
        }
    };

    const handlerShowModalPlans = () => {
        setShowModalPlans(true);
        fetchDataPlans();
    }

    const handlerShowModalPayment = (data: StrategyStatementPayment) => {
        setChosenData(data);
    }

    useEffect(() => {
        if (chosenData.id !== "") {
            setShowModalPlans(false);
            setTimeout(() => {
                setShowModalPayment(true);
                fetchDataPayment();
            }, 500);
        }
    }, [chosenData])

    return (
        <>
            <Button variant="outline-primary" onClick={() => handlerShowModalPlans()}>{strings.status.ACTIVATED.button_label}</Button>

            <Modal show={showModalPlans} fullscreen={true} onHide={() => setShowModalPlans(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{strings.modal_plans_title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {isLoading
                        ? <Spinner animation="border" variant="primary" />
                        : factorySubscription.create(plansData, signedPlan, handlerShowModalPayment)}
                </Modal.Body>
            </Modal>

            <Modal show={showModalPayment} fullscreen={true} onHide={() => setShowModalPayment(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{strings.modal_payment_title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {isLoading ? <Spinner /> : factoryPayment.create(paymentData, chosenData, true)}
                </Modal.Body>
            </Modal>
        </>
    )
}